import { axiosProxy as axios } from "@dev/open-proxy-axios";

const optionalConfig = {
  delayRequestTime: 10, // in seconds
  requestLimitPerTimeMetric: 100,
  timeMetric: 60, // in seconds
  tokenDuration: 120, // in seconds
  emsiServiceUrl: "/postings"
};

const api = axios.create({
  jwtKey: process.env.REACT_APP_JWT_KEY,
  jwtSecret: "daily-postings-dashboard-secret",
  ...optionalConfig
})

export default api;
